import React from "react";
import UserMenu from "../user/userMenu";
import ImpersonationMenu from "../user/ImpersonationMenu";
import { Link } from "react-router-dom";
import { Navbar, Container, Nav } from "react-bootstrap";
import { userActions } from "../../actions/user.actions";
import { useDispatch } from "react-redux";
import { useOktaAuth } from "@okta/okta-react";
import armaninoLogo from "../../assets/armanino-llp.png";
import armaninoLogoDark from "../../assets/Armanino-logo-reversed.png";
import HelpMenu from "./HelpMenu";
import DarkModeToggle from "./DarkModeToggle";
import WorkspaceExperienceToggle from "./WorkspaceExperienceToggle";
import HamburgerMenu from "./HamburgerMenu";
import { useDarkMode } from "../../contexts/DarkModeContext";
import { useWorkspaceExperience } from "../../contexts/WorkspaceExperienceContext";

function Header(props) {
  const user = props.user;
  const dispatch = useDispatch();
  const { oktaAuth } = useOktaAuth();
  const { darkMode } = useDarkMode();
  const { workspaceExperienceEnabled } = useWorkspaceExperience();

  const handleSignOut = async () => {
    try {
      await oktaAuth.signOut();
    } catch {}

    dispatch(userActions.logout());
  };

  return (
    <>
      {user && (
        <Navbar className="modern-header sticky-top py-3">
          <Container>
            <div className="d-flex align-items-center gap-3">
              <HamburgerMenu
                isOpen={props.mobileMenuOpen}
                onToggle={props.onToggleMobileMenu}
              />
              <Nav.Item>
                <Link to={workspaceExperienceEnabled ? "/workspace" : "/dashboard"}>
                  <img
                    src={darkMode ? armaninoLogoDark : armaninoLogo}
                    alt="Armanino"
                    width={100}
                    className="header-logo"
                  />
                </Link>
              </Nav.Item>
            </div>
            <div className="d-flex align-items-center gap-3">
              {/* Opt-in is restricted to Product Team/Super Users, but if a user somehow
                  already has it enabled (e.g. a role change), still show the toggle so they
                  have a way back to the classic view rather than being stuck. */}
              {(user.isSuperUser || user.isProductTeam || workspaceExperienceEnabled) && (
                <div className="d-none d-md-block">
                  <WorkspaceExperienceToggle />
                </div>
              )}
              <div className="d-none d-md-block">
                <DarkModeToggle />
              </div>
              <div className="d-none d-md-block">
                <HelpMenu user={user} />
              </div>
              {(user.isSuperUser || user.isImpersonating) && (
                <div className="d-none d-md-block">
                  <ImpersonationMenu user={user} />
                </div>
              )}
              <UserMenu user={user} onSignOut={handleSignOut} />
            </div>
          </Container>
        </Navbar>
      )}
    </>
  );
}
export default Header;
